import {
    START_LOADING,
    END_LOADING,
    FETCH_PROPERTIES,
    FETCH_PROPERTY,
    UPDATE_PROPERTY,
    CREATE_PROPERTY,
    DELETE_PROPERTY,
    ERROR_PROPERTY,
    UPLOAD_ATTACHMENTS,
    ERROR_UPLOADING_ATTACHMENTS,
    DELETE_ATTACHMENT
} from "../actions/constants";

const initialState = {
    isLoading: false,
    error: null,
    properties: [],
    property: null,
    attachments: [],
};
const property = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true, error: null };
        case END_LOADING:
            return { ...state, isLoading: false };
        case FETCH_PROPERTIES:
            return {
                ...state,
                properties: action.payload.data,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages,
            };
        case FETCH_PROPERTY:
            return { ...state, property: action.payload };
        case CREATE_PROPERTY:
            return {
                ...state,
                properties: [...state.properties, action.payload],
            };
        case UPDATE_PROPERTY:
            return {
                ...state,
                properties: state.properties.map((property) =>
                    property._id === action.payload._id ? action.payload : property
                ),
                asset:
                    state.asset && state.asset._id === action.payload._id
                        ? action.payload
                        : state.asset,
            };
        case DELETE_PROPERTY:
            return {
                ...state,
                properties: state.properties.filter(
                    (property) => property._id !== action.payload
                ),
            };
        case ERROR_PROPERTY:
            return {
                ...state,
                error: action.payload,
            };
        case UPLOAD_ATTACHMENTS:
            return {
                ...state,
                attachments: [...state.attachments, action.payload],
            };
        case DELETE_ATTACHMENT:
            return {
                ...state,
                attachments: state.attachments.filter(
                    (attachment) => attachment._id !== action.payload
                ),
            };
        case ERROR_UPLOADING_ATTACHMENTS:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
export default property;